import { useEffect, useState } from 'react';
import type { PublicStatusResponse } from '@nadoutong/contracts';
import { PLATFORM_BASE_URL } from '../config/endpoints.ts';

interface StatusState {
  data: PublicStatusResponse | null;
  loading: boolean;
  error: boolean;
}

export function useStatus(): StatusState {
  const [state, setState] = useState<StatusState>({
    data: null,
    loading: true,
    error: false,
  });

  useEffect(() => {
    fetch(`${PLATFORM_BASE_URL}/v1/status`)
      .then(async (res) => {
        if (!res.ok) throw new Error(`${res.status}`);
        const json = (await res.json()) as PublicStatusResponse;
        setState({ data: json, loading: false, error: false });
      })
      .catch(() => {
        setState({ data: null, loading: false, error: true });
      });
  }, []);

  return state;
}
